import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-years-dialog',
  templateUrl: './two-years-dialog.component.html',
  styleUrls: ['./two-years-dialog.component.css']
})
export class TwoYearsDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}